






















import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {
  },
})
export default class Home extends Vue {
  options = [
    {
      label: 'Word Counter',
      path: '/words'
    },
    {
      label: 'Days Calculator',
      path: '/days'
    }
  ]
}
